// Vite entrypoint for Rails application
import "@hotwired/turbo-rails";
import "../styles/application.css";
import "@/controllers";
import * as ActiveStorage from "@rails/activestorage";
ActiveStorage.start();
// ActionText's autostart() checks window.ActiveStorage to initialize
// direct upload support. The ESM import doesn't set this global, so
// we must expose it manually before importing ActionText.
window.ActiveStorage = ActiveStorage;
import "trix";
import "@rails/actiontext";
import "choices.js/public/assets/styles/choices.min.css";

// jQuery setup - MUST be before DataTables
import jQuery from "jquery";
window.jQuery = jQuery;
window.$ = jQuery;

// DataTables - Load after jQuery is global
import DataTable from 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
window.DataTable = DataTable;

// Charts - Import Chart.js and configure Chartkick
import { Chart, registerables } from 'chart.js';
import 'chartjs-adapter-date-fns';
import Chartkick from "chartkick";

// Register all Chart.js components
Chart.register(...registerables);

// Make Chart.js available globally BEFORE Chartkick
window.Chart = Chart;

// Configure Chartkick to use Chart.js and disable auto-rendering
Chartkick.options = {
  adapter: "chartjs"
};
Chartkick.use(Chart);

// Make Chartkick available globally
window.Chartkick = Chartkick;

// Wait for page to be fully loaded before rendering charts
function renderAllCharts() {
  if (window.Chartkick && window.Chart) {
    setTimeout(() => {
      window.Chartkick.eachChart((chart) => {
        if (!chart.chart) {
          try {
            chart.redraw();
          } catch (e) {
            console.error('Error rendering chart:', e);
          }
        }
      });
    }, 100);
  }
}

// Auto-render charts on page load and Turbo navigation
document.addEventListener('turbo:load', renderAllCharts);
document.addEventListener('turbo:render', renderAllCharts);

// Also trigger on DOMContentLoaded for initial page load
document.addEventListener('DOMContentLoaded', renderAllCharts);

// Ensure charts render after Turbo frame updates
document.addEventListener('turbo:frame-load', renderAllCharts);

// Custom modules
import "@/src/youtube";
import "@/src/init_datatables";
import "@/src/trix_extensions";
import "@/src/currency_input";
import "@/src/time_entry_rate";
import "@/src/mention_autocomplete";